module.exports = __webpack_public_path__ + "static/media/range_1_orange.94ffb601.png";